/* components/SiteSearch.ts
The main navigation search input
*/

import { Component, Ref, SimpleEvent, log } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '../../theme/ThemeComponent';

@Component
export class SiteSearch extends ThemeComponent {
    private openTriggers: NodeListOf<HTMLElement>;
    private closeTriggers: NodeListOf<HTMLElement>;
    private searchInput: HTMLInputElement | null;
    private predictiveSearchResults: HTMLDivElement | null;

    constructor() {
        super();
        this.openTriggers = document.querySelectorAll('.site-search__open');
        this.closeTriggers = this.querySelectorAll('.site-search__close');
        this.searchInput = this.querySelector('.site-search__input');
        this.predictiveSearchResults = document.querySelector('#site-header__predictive-search');
    }

    init() {
        for (const trigger of this.openTriggers) {
            trigger.addEventListener('click', () => {
                if (document.body.classList.contains('search--open')) {
                    this.closeSearch();
                } else {
                    this.showSearch();
                }
            });
        }

        for (const trigger of this.closeTriggers) {
            trigger.addEventListener('click', () => {
                this.closeSearch();
            });
        }
    }

    showSearch() {
        document.body.classList.add('search--open');

        // If the search input is blank, show suggestions
        if (this.searchInput?.value == '') {
            document.body.classList.add('suggestions--open');
        }
    }

    closeSearch() {
        document.body.classList.remove('search--open');
        if (this.searchInput) {
            this.searchInput.value = '';
        }
        document.body.classList.remove('suggestions--open');
        if (this.predictiveSearchResults) {
            this.predictiveSearchResults.style.display = 'none';
        }

    }
}
